import {
    AccordionGroup_experimental as AccordionGroup,
    AccordionItem_experimental as AccordionItem,
    Link,
} from '@coop/components';
import classNames from 'classnames';

import styles from './Footer.module.scss';
import FooterColumns from './FooterColumns';

const FooterMobile = (props: Pick<FrontendFooter, 'columns'>) => {
    if (window.isPrerenderCrawler) {
        return <FooterColumns columns={props.columns} />;
    }

    return (
        <AccordionGroup
            className={classNames(styles.FooterAccordion, styles.AccordionGroup)}
            variant="Quiet"
            size="small"
        >
            {props.columns.map((column) => (
                <AccordionItem
                    size="small"
                    key={column.headerLink?.contentId}
                    title={column.header || ''}
                    headingLevel={2}
                >
                    <ul className={styles.FooterList}>
                        {column.links.map((link) => (
                            <li className={styles.FooterItem} key={link.contentId}>
                                <Link href={link.url} size="small">
                                    {link.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </AccordionItem>
            ))}
        </AccordionGroup>
    );
};

export default FooterMobile;
